import type { Thread } from '../types/chat';

export const threads: Thread[] = [
  {
    id: 't-1004',
    chefId: 'chef-priya',
    customerId: 'cus-dana',
    bookingId: 'bk-1004',
    subject: 'Birthday thali · 14 Sep · 6 guests',
    lastAt: '2026-09-02T16:22:00.000Z',
    unreadForCustomer: 2,
    unreadForChef: 0,
    messages: [
      {
        id: 'm-1',
        threadId: 't-1004',
        role: 'system',
        kind: 'system',
        body: 'Dao requested a quote for Birthday · 14 September · 6 guests · cooking at their place.',
        language: 'en-TH',
        at: '2026-08-31T10:12:00.000Z',
        read: true,
      },
      {
        id: 'm-2',
        threadId: 't-1004',
        role: 'customer',
        kind: 'text',
        body: 'Hi Priya! It is my partner’s birthday and he has been talking about your thali since we saw it. Six of us including our daughter, who is nine and will find anything above mild upsetting. Also — my shellfish allergy is the serious kind, and there are peanuts to avoid for her.',
        language: 'en-TH',
        at: '2026-08-31T10:14:00.000Z',
        read: true,
      },
      {
        id: 'm-3',
        threadId: 't-1004',
        role: 'chef',
        kind: 'text',
        body: 'Hello Dao — no shellfish comes into my kitchen at all, so that part is easy. For Ing I will pull a mild sambar before I add the second chilli, and I will leave the cashew garnish off the payasam entirely rather than serving it on the side.',
        language: 'en-TH',
        at: '2026-08-31T11:02:00.000Z',
        read: true,
      },
      {
        id: 'm-4',
        threadId: 't-1004',
        role: 'chef',
        kind: 'quote',
        body: 'First quote — three hours, seven dishes.',
        language: 'en-TH',
        at: '2026-09-01T14:05:00.000Z',
        quoteId: 'q-1004-v1',
        read: true,
      },
      {
        id: 'm-5',
        threadId: 't-1004',
        role: 'customer',
        kind: 'text',
        body: 'This looks great. Could we stretch it a bit so people are not rushed, and is there any way to do filter coffee at the end? He is very serious about coffee.',
        language: 'en-TH',
        at: '2026-09-02T09:30:00.000Z',
        read: true,
      },
      {
        id: 'm-6',
        threadId: 't-1004',
        role: 'chef',
        kind: 'text',
        body: 'Of course. I have added a fourth hour and the filter coffee and chai service, and re-sent it below. Everything else is unchanged.',
        language: 'en-TH',
        at: '2026-09-02T16:20:00.000Z',
        read: false,
      },
      {
        id: 'm-7',
        threadId: 't-1004',
        role: 'chef',
        kind: 'quote',
        body: 'Updated quote — version 2.',
        language: 'en-TH',
        at: '2026-09-02T16:22:00.000Z',
        quoteId: 'q-1004',
        read: false,
      },
    ],
  },
  {
    id: 't-1003',
    chefId: 'chef-kenji',
    customerId: 'cus-dana',
    bookingId: 'bk-1003',
    subject: 'Omakase · 19 Sep · 4 guests',
    lastAt: '2026-08-28T20:12:00.000Z',
    unreadForCustomer: 0,
    unreadForChef: 0,
    messages: [
      {
        id: 'm-10',
        threadId: 't-1003',
        role: 'customer',
        kind: 'text',
        body: 'Our anniversary. Four of us at the counter. I should flag that my shellfish allergy is anaphylactic — is an omakase still possible?',
        language: 'en-TH',
        at: '2026-08-26T09:02:00.000Z',
        read: true,
      },
      {
        id: 'm-11',
        threadId: 't-1003',
        role: 'chef',
        kind: 'text',
        body: 'はい、可能です。甲殻類を一切使わない構成にし、まな板と包丁も別のものを持参します。牡丹海老の一皿は熟成カンパチに変えますが、正直そちらの方が良い一皿です。',
        language: 'ja-JP',
        translations: {
          'en-TH':
            'Yes. I will build the sequence without shellfish and bring separate boards and knives. The botan ebi course becomes aged kanpachi, which is arguably the better plate anyway.',
          'th-TH':
            'ได้ครับ ผมจะจัดคอร์สโดยไม่ใช้สัตว์น้ำมีเปลือกเลย และนำเขียงกับมีดแยกมาเอง จานกุ้งโบตันจะเปลี่ยนเป็นคันปาจิบ่ม ซึ่งจริง ๆ อร่อยกว่าด้วย',
        },
        at: '2026-08-27T12:40:00.000Z',
        read: true,
      },
      {
        id: 'm-12',
        threadId: 't-1003',
        role: 'chef',
        kind: 'quote',
        body: 'Quote for the 19th.',
        language: 'en-TH',
        at: '2026-08-28T15:40:00.000Z',
        quoteId: 'q-1003',
        read: true,
      },
      {
        id: 'm-13',
        threadId: 't-1003',
        role: 'system',
        kind: 'system',
        body: 'Dao accepted the quote. Deposit of ฿12,994 authorized — booking PA-1003 confirmed.',
        language: 'en-TH',
        at: '2026-08-28T20:11:00.000Z',
        read: true,
      },
      {
        id: 'm-14',
        threadId: 't-1003',
        role: 'chef',
        kind: 'text',
        body: 'Thank you. I will confirm the fish list two days before. Please keep one clear metre of counter and the sink free from 5pm.',
        language: 'en-TH',
        at: '2026-08-28T20:12:00.000Z',
        read: true,
      },
    ],
  },
  {
    id: 't-1005',
    chefId: 'chef-sofia',
    customerId: 'cus-dana',
    bookingId: 'bk-1005',
    subject: 'Hanoi table · 3 Oct · 5 guests',
    lastAt: '2026-09-03T07:45:00.000Z',
    unreadForCustomer: 1,
    unreadForChef: 0,
    messages: [
      {
        id: 'm-20',
        threadId: 't-1005',
        role: 'customer',
        kind: 'text',
        body: 'Five of us, all vegetarian except one who eats fish. One guest is dairy-free. Is the Hanoi table workable?',
        language: 'en-TH',
        at: '2026-09-02T20:42:00.000Z',
        read: true,
      },
      {
        id: 'm-21',
        threadId: 't-1005',
        role: 'chef',
        kind: 'text',
        body: 'Very workable — the pâté becomes a mushroom version for the vegetarians and the flan goes coconut for the dairy-free guest. Before I price it: is your hob induction or gas? The broth and the bún both want real heat at the same time.',
        language: 'en-TH',
        at: '2026-09-03T07:45:00.000Z',
        read: false,
      },
    ],
  },
  {
    id: 't-2001',
    chefId: 'chef-elena',
    customerId: 'cus-rafael',
    bookingId: 'bk-2001',
    subject: 'Weeknight Thai table · 6 Sep · 8 guests',
    lastAt: '2026-09-02T19:10:00.000Z',
    unreadForCustomer: 0,
    unreadForChef: 1,
    messages: [
      {
        id: 'm-30',
        threadId: 't-2001',
        role: 'customer',
        kind: 'text',
        body: 'プロイさん、こんにちは！日曜日は8名です。妹のためにグルテンフリーの麺を用意していただけますか？',
        language: 'ja-JP',
        translations: {
          'en-TH': 'Hi Ploy! There are eight of us on Sunday. Could you prepare gluten-free noodles for my sister?',
          'th-TH': 'สวัสดีค่ะคุณพลอย วันอาทิตย์เรามี 8 คนนะคะ ขอเส้นแบบไม่มีกลูเตนสำหรับน้องสาวได้ไหมคะ',
        },
        at: '2026-08-22T18:04:00.000Z',
        read: true,
      },
      {
        id: 'm-31',
        threadId: 't-2001',
        role: 'chef',
        kind: 'text',
        body: 'Yes — I use separate rice noodles and keep them on their own board and wok. Groceries are at cost on this menu, so I will photograph the receipts the same night.',
        language: 'en-TH',
        translations: {
          'ja-JP':
            'はい。別のライスヌードルを使い、まな板と中華鍋も分けます。このメニューは食材費が実費なので、当日の夜にレシートの写真をお送りします。',
        },
        at: '2026-08-23T09:20:00.000Z',
        read: true,
      },
      {
        id: 'm-32',
        threadId: 't-2001',
        role: 'chef',
        kind: 'quote',
        body: 'Quote for Sunday.',
        language: 'en-TH',
        at: '2026-08-24T11:00:00.000Z',
        quoteId: 'q-2001',
        read: true,
      },
      {
        id: 'm-33',
        threadId: 't-2001',
        role: 'system',
        kind: 'system',
        body: 'Yuki accepted the quote. Deposit of ฿3,248 authorized — booking PA-2001 confirmed.',
        language: 'en-TH',
        at: '2026-08-24T14:30:00.000Z',
        read: true,
      },
      {
        id: 'm-34',
        threadId: 't-2001',
        role: 'customer',
        kind: 'text',
        body: 'ありがとうございます。もう一つ、到着前に何か買っておく必要はありますか？',
        language: 'ja-JP',
        translations: {
          'en-TH': 'Thank you. One more thing: do you need me to buy anything before you arrive?',
          'th-TH': 'ขอบคุณค่ะ อีกเรื่องหนึ่ง ต้องซื้ออะไรเตรียมไว้ก่อนเชฟมาไหมคะ',
        },
        at: '2026-09-02T19:10:00.000Z',
        read: false,
      },
    ],
  },
  {
    id: 't-2002',
    chefId: 'chef-elena',
    customerId: 'cus-yuki',
    bookingId: 'bk-2002',
    subject: 'Date night · 21 Sep · 2 guests',
    lastAt: '2026-09-03T08:16:00.000Z',
    unreadForCustomer: 0,
    unreadForChef: 2,
    messages: [
      {
        id: 'm-40',
        threadId: 't-2002',
        role: 'system',
        kind: 'system',
        body: 'Chen Wei requested a quote for Date night · 21 September · 2 guests · cooking at their place.',
        language: 'en-TH',
        at: '2026-09-03T08:15:00.000Z',
        read: false,
      },
      {
        id: 'm-41',
        threadId: 't-2002',
        role: 'customer',
        kind: 'text',
        body: '想订一个纪念日晚餐，只有我们两个人。可以完全不用乳制品吗？',
        language: 'zh-CN',
        translations: {
          'en-TH': 'I would like to book an anniversary dinner. Just the two of us — could you cook without any dairy?',
          'th-TH': 'อยากจองมื้อค่ำวันครบรอบค่ะ มีแค่สองคน ทำแบบไม่ใส่นมและเนยได้ไหมคะ',
        },
        at: '2026-09-03T08:16:00.000Z',
        read: false,
      },
    ],
  },
  {
    id: 't-1001',
    chefId: 'chef-elena',
    customerId: 'cus-dana',
    bookingId: 'bk-1001',
    subject: 'Baan Ploy tasting · 22 Aug · 6 guests',
    lastAt: '2026-08-23T09:20:00.000Z',
    unreadForCustomer: 0,
    unreadForChef: 0,
    messages: [
      {
        id: 'm-50',
        threadId: 't-1001',
        role: 'system',
        kind: 'system',
        body: 'Booking PA-1001 completed. Balance of ฿17,549 charged.',
        language: 'en-TH',
        at: '2026-08-23T01:30:00.000Z',
        read: true,
      },
      {
        id: 'm-51',
        threadId: 't-1001',
        role: 'customer',
        kind: 'text',
        body: 'Thank you for a genuinely perfect evening. My mother has already asked how long you pound the paste for.',
        language: 'en-TH',
        at: '2026-08-23T09:14:00.000Z',
        read: true,
      },
      {
        id: 'm-52',
        threadId: 't-1001',
        role: 'chef',
        kind: 'text',
        body: 'Tell her: another ten minutes, and always the galangal first. Any time, Dao.',
        language: 'en-TH',
        at: '2026-08-23T09:20:00.000Z',
        read: true,
      },
    ],
  },
];

export function threadsForCustomer(customerId: string): Thread[] {
  return threads.filter((t) => t.customerId === customerId).sort((a, b) => b.lastAt.localeCompare(a.lastAt));
}

export function threadsForChef(chefId: string): Thread[] {
  return threads.filter((t) => t.chefId === chefId).sort((a, b) => b.lastAt.localeCompare(a.lastAt));
}
